<!-- SaveButtonCellRendererComponent used by AG Grid columnDefs cellRenderer -->
@if (false) {
  <app-save-button-cell-renderer />
}
<section class="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
  <div class="mb-4">
    <h2 class="text-lg font-semibold text-slate-800">User Management</h2>
    <p class="mt-1 text-sm text-slate-500">
      View and edit subscription tier, start date, and end date for all registered users.
    </p>
  </div>

  @if (loading()) {
    <div class="flex items-center justify-center py-12 text-sm text-slate-500">
      <svg
        class="mr-2 h-5 w-5 animate-spin text-slate-400"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      Loading users...
    </div>
  } @else if (error()) {
    <div class="rounded-md bg-red-50 p-4 text-sm text-red-700">
      {{ error() }}
      <button
        type="button"
        (click)="loadUsers()"
        class="ml-2 font-medium underline hover:no-underline"
      >
        Retry
      </button>
    </div>
  } @else {
    <div class="overflow-hidden rounded-lg border border-slate-200 shadow-sm">
      <ag-grid-angular
        style="width: 100%; height: 500px"
        [theme]="theme"
        [rowData]="users()"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [context]="getGridContext()"
        [stopEditingWhenCellsLoseFocus]="true"
        (gridReady)="onGridReady($event)"
        (cellValueChanged)="onCellValueChangedHandler($event)"
      />
    </div>
  }
</section>
